"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserTitleUpdater = exports.BrowserTitleUpdateType = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const react_1 = tslib_1.__importDefault(require("react"));
// The BrowserTitleUpdateTypes should align with the applicable public helper methods in
// VPC's BrowserTitleService.ts which get called through UIActions
var BrowserTitleUpdateType;
(function (BrowserTitleUpdateType) {
    BrowserTitleUpdateType["TITLE_WITH_PLACE_ENTITY_NAME"] = "TITLE_WITH_PLACE_ENTITY_NAME";
    BrowserTitleUpdateType["TITLE_WITH_PLACE_NAME_FUNCTION"] = "TITLE_WITH_PLACE_NAME_FUNCTION";
    BrowserTitleUpdateType["TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME"] = "TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME";
})(BrowserTitleUpdateType = exports.BrowserTitleUpdateType || (exports.BrowserTitleUpdateType = {}));
// TODO: add typeguards here to clean up mess of ternary expressions
function BrowserTitleUpdater(props) {
    const uiActions = (0, catalog_core_1.useUIActions)();
    const { browserTitleUpdateType } = props;
    const name = browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_PLACE_ENTITY_NAME
        || browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME
        ? props.name
        : '';
    return (react_1.default.createElement(BrowserTitleUIActionsUpdater, { browserTitleUpdateType: browserTitleUpdateType, uiActions: uiActions, name: name, nameFunction: browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_PLACE_NAME_FUNCTION
            ? props.nameFunction
            : () => '', subspaceName: browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME
            ? props.subspaceName
            : '' }));
}
exports.BrowserTitleUpdater = BrowserTitleUpdater;
class BrowserTitleUIActionsUpdater extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.localIsMounted = false;
    }
    componentDidMount() {
        this.localIsMounted = true;
        this.updateBrowserTitle();
    }
    componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name || this.props.nameFunction !== prevProps.nameFunction
            || this.props.uiActions !== prevProps.uiActions) {
            this.updateBrowserTitle();
        }
    }
    updateBrowserTitle() {
        // setTimeout of 0 is used here to ensure that our browser title update gets called after VPC's set default browser title call
        setTimeout(() => {
            if (this.localIsMounted) {
                this.makeUpdateBrowserTitleUiActionsCall();
            }
        }, 0);
    }
    makeUpdateBrowserTitleUiActionsCall() {
        switch (this.props.browserTitleUpdateType) {
            case BrowserTitleUpdateType.TITLE_WITH_PLACE_ENTITY_NAME: {
                if (this.props.name) {
                    this.props.uiActions.setBrowserTitleWithPlaceEntityName(this.props.name);
                }
                break;
            }
            case BrowserTitleUpdateType.TITLE_WITH_PLACE_NAME_FUNCTION: {
                if (this.props.nameFunction) {
                    this.props.uiActions.setBrowserTitleWithPlaceNameFunction(this.props.nameFunction);
                }
                break;
            }
            case BrowserTitleUpdateType.TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME: {
                if (this.props.name) {
                    this.props.uiActions.setBrowserTitleWithSpaceEntityNameAndTranslatedSubspaceName(this.props.name, this.props.subspaceName);
                }
                break;
            }
            default:
                break;
        }
    }
    render() {
        return null;
    }
    componentWillUnmount() {
        this.localIsMounted = false;
    }
}
//# sourceMappingURL=BrowserTitleUpdater.js.map